export default [
  // 账户总览
  {
    path: 'account',
    name: 'assetsAccount',
    meta: {
      mustLogin: true,
      navName: 'account',
      activeName: 'assets',
      h5NavName: 'account',
      pageTitle: 'assets',
    },
    component: () => import('@/views/assets/account.vue'),
  },
  // 现货账户
  {
    path: 'exchangeAccount',
    name: 'assetsExchangeAccount',
    meta: {
      mustLogin: true,
      navName: 'exchangeAccount',
      activeName: 'assets',
      h5NavName: 'exchangeAccount',
      pageTitle: 'assets',
    },
    component: () => import('@/views/assets/exchangeAccount.vue'),
  },
  // 充值
  {
    path: 'recharge',
    name: 'assetsRecharge',
    meta: {
      mustLogin: true,
      navName: 'exchangeAccount',
      activeName: 'assets',
      h5NavName: 'exchangeAccount',
      pageTitle: 'assets',
    },
    component: () => import('@/views/assets/recharge.vue'),
  },
  // 提现
  {
    path: 'withdraw',
    name: 'assetsWithdraw',
    meta: {
      mustLogin: true,
      navName: 'exchangeAccount',
      activeName: 'assets',
      h5NavName: 'exchangeAccount',
      pageTitle: 'assets',
    },
    component: () => import('@/views/assets/withdraw.vue'),
  },
  // 资金流水
  {
    path: 'flowingWater',
    name: 'assetsFlowingWater',
    meta: {
      mustLogin: true,
      navName: 'flowingWater',
      activeName: 'assets',
      h5NavName: 'exchangeAccount',
      pageTitle: 'assets',
    },
    component: () => import('@/views/assets/flowingWater.vue'),
  },
  // 地址管理
  {
    path: 'addressMent',
    name: 'assetsAddressMent',
    meta: {
      mustLogin: true,
      navName: 'addressMent',
      activeName: 'assets',
      h5NavName: 'exchangeAccount',
      pageTitle: 'assets',
    },
    component: () => import('@/views/assets/addressMent.vue'),
  },
  // 法币账户
  {
    path: 'otcAccount',
    name: 'assetsOtcAccount',
    meta: {
      mustLogin: true,
      navName: 'otcAccount',
      activeName: 'assets',
      h5NavName: 'otcAccount',
      pageTitle: 'assets',
    },
    component: () => import('@/views/assets/otcAccount.vue'),
  },
  // 法币资金流水
  {
    path: 'otcFlowingWater',
    name: 'assetsOtcFlowingWater',
    meta: {
      mustLogin: true,
      navName: 'otcFlowingWater',
      activeName: 'assets',
      h5NavName: 'otcAccount',
      pageTitle: 'assets',
    },
    component: () => import('@/views/assets/otcFlowingWater.vue'),
  },
  // 合约账户
  {
    path: 'coAccount',
    name: 'assetsCoAccount',
    meta: {
      mustLogin: true,
      navName: 'coAccount',
      activeName: 'assets',
      h5NavName: 'coAccount',
      pageTitle: 'assets',
    },
    component: () => import('@/views/assets/coAccount.vue'),
  },
  // 合约资金流水
  {
    path: 'coFlowingWater',
    name: 'assetsCoFlowingWater',
    meta: {
      mustLogin: true,
      navName: 'coFlowingWater',
      activeName: 'assets',
      h5NavName: 'coAccount',
      pageTitle: 'assets',
    },
    component: () => import('@/views/assets/coFlowingWater.vue'),
  },
];
